const ResultModal = ({ setCurrentModal, resultModalRef, responseMessage }) => {

  const handleBookButtonClick = () => {
    setCurrentModal("bookModal");
  }

  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={resultModalRef} id="modalResult" tabIndex="-1" aria-labelledby="modalForm" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalForm">Your Halal Itinerary</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body response">
              <div className="modal-subcontent" dangerouslySetInnerHTML={{ __html: responseMessage }} ></div>
            </div>

            {/* Invitation for Exclusive Consultation */}
            <div className="exclusiveInvit">
              <p>Your travel itinerary is ready! Now, it’s time to turn it into a reality. Get all your travel essentials in one convenient travel package tailored to this itinerary by clicking the button below!</p>
              <button className="btn modal-btn btn-grad" onClick={handleBookButtonClick}>
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResultModal